"use strict";

import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/objectWithoutProperties";
const _excluded = ["children"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { TENANT_NAME } from '@autoguru/global-configs';
import { lazy } from 'react';
import { default as SupplierProviderLegacy, useSupplierLegacy } from '../SupplierProvider_Legacy/SupplierProviderLegacy';
import { jsx as _jsx } from "react/jsx-runtime";
const DistributedSupplierProvider = /*#__PURE__*/lazy(async () => import('../GlobalSupplierProvider/GlobalSupplierProvider'));
export const useSupplier = useSupplierLegacy;
export const SupplierProvider = _ref => {
  let {
      children
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return TENANT_NAME !== 'nz' ? /*#__PURE__*/_jsx(SupplierProviderLegacy, _objectSpread(_objectSpread({}, props), {}, {
    children: children
  })) : /*#__PURE__*/_jsx(DistributedSupplierProvider, {
    children: /*#__PURE__*/_jsx(SupplierProviderLegacy, _objectSpread(_objectSpread({}, props), {}, {
      children: children
    }))
  });
};